import { createFileRoute } from '@tanstack/react-router';
import { ContactSupport } from '../components/ContactSupport';

export const Route = createFileRoute('/contact-support')({
  component: ContactSupportComponent,
});

function ContactSupportComponent() {
  return (
    <div className="App">
      <ContactSupport />
    </div>
  );
}

